import React from 'react'
import styles from './TopBarShell.module.scss'

interface TopBarShellProps {
  children: React.ReactNode
  className?: never
}

export const TopBarShell: React.FC<TopBarShellProps> = ({ children }) => (
  <div className={styles.topbar}>{children}</div>
)
